import React from 'react';
import { Button } from '../ui/button';

export const Navbar = ({ scrollY, scrollToBooking }) => (
  <nav
    className="fixed top-0 w-full z-50 transition-all duration-300"
    style={{
      backgroundColor: scrollY > 50 ? 'rgba(245, 241, 232, 0.95)' : 'transparent',
      backdropFilter: scrollY > 50 ? 'blur(12px)' : 'none',
      boxShadow: scrollY > 50 ? '0 4px 20px rgba(139, 115, 85, 0.1)' : 'none',
    }}
    data-testid="home-navbar"
  >
    <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
      <div className="flex items-center gap-3">
        <img
          src="https://customer-assets.emergentagent.com/job_6bd1bdb6-929b-492c-804f-03ddd69ea176/artifacts/udp9h1gt_SHOT%20TO%20THE%20NINES.png"
          alt="Shot to the Nines"
          className="h-16 object-contain"
        />
      </div>
      <div className="hidden md:flex gap-8 items-center">
        <a href="#about" className="text-[#8B7355] hover:text-[#C9A961] transition-colors font-serif">Our Story</a>
        <a href="#booth" className="text-[#8B7355] hover:text-[#C9A961] transition-colors font-serif">The Booth</a>
        <a href="#packages" className="text-[#8B7355] hover:text-[#C9A961] transition-colors font-serif">Packages</a>
        <a href="#gallery" className="text-[#8B7355] hover:text-[#C9A961] transition-colors font-serif">Gallery</a>
        <Button
          onClick={scrollToBooking}
          className="bg-[#8B7355] hover:bg-[#6B5845] text-white px-6 py-2 rounded-none font-serif"
          data-testid="nav-book-btn"
        >
          Book Your Event
        </Button>
      </div>
    </div>
  </nav>
);
